<back-button [show]="'true'" backPage="Certificate Counts Details"></back-button>

<ion-content>
  <ion-grid class="ion-no-padding grid-card">
    <ion-row>
      <ion-col [size]="certificateColSize" *ngFor="let item of certArr">
        <ion-card class="common-card certificate-card">
          <img [src]="item[imageKey]" (click)="goToCertificateDatail(item,item.certificateCategory)">
          <ion-item class="btn-item height-auto" lines="none">
            <ion-label class="mr-0 ion-text-wrap"> {{'giftCertificate.validTill' | translate}} -
              {{item?.validTill |
              date : "MM/yy" }}</ion-label>
          </ion-item>
        </ion-card>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>